import { resolveCountrySpecificValue } from '@scentregroup/shared/configuration'
import { getSharedEnv } from '../src/shared/lib/env'
import { staticSharedEnv } from '../src/shared/lib/shared-env'
import { Country } from '../src/shared/types/country'
import {
  IMarketplaceSiteConfiguration,
  ISiteConfiguration,
} from '../src/shared/types/site-configuration'

function makeMarketplaceSiteConfiguration(): IMarketplaceSiteConfiguration {
  return {
    urls: {
      faq: getSharedEnv('urls.faq'),
      termsAndConditions: getSharedEnv('urls.termsAndConditions'),
      directReturnPolicy: getSharedEnv('urls.directReturnPolicy'),
    },
  }
}

export const getSiteConfiguration = (country: Country): ISiteConfiguration => ({
  country,
  privacyPolicyUrl: resolveCountrySpecificValue(
    staticSharedEnv.urls.privacyPolicy,
    country
  ),
  marketplace: makeMarketplaceSiteConfiguration(),
})
